export const FETCH_STATE = {
  IDLE: "idle",
  LOADING: "pending",
  SUCCESS: "success",
  ERROR: "error",
};
